import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Clock, PlayCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";

interface InProgressTestCardProps {
  testResponseId: string;
  testId: string;
  testTitle: string;
  lastQuestionIndex: number;
  totalQuestions: number;
  startedAt: string;
}

export function InProgressTestCard({
  testResponseId,
  testId,
  testTitle,
  lastQuestionIndex,
  totalQuestions,
  startedAt,
}: InProgressTestCardProps) {
  const navigate = useNavigate();
  const progress = ((lastQuestionIndex + 1) / totalQuestions) * 100;
  const timeAgo = formatDistanceToNow(new Date(startedAt), { addSuffix: true });

  const handleResume = () => {
    navigate(`/test/${testId}/take?responseId=${testResponseId}`);
  };

  return (
    <Card className="p-4 border-primary/20 bg-card hover:border-primary/40 transition-colors">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 space-y-3">
          <div>
            <h3 className="font-semibold text-foreground mb-1">{testTitle}</h3>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-3.5 w-3.5" />
              <span>Started {timeAgo}</span>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Progress</span>
              <span className="font-medium text-foreground">
                Question {lastQuestionIndex + 1} of {totalQuestions}
              </span>
            </div>
            <Progress value={progress} className="h-2" />
          </div>
        </div>

        <Button onClick={handleResume} size="sm" className="shrink-0">
          <PlayCircle className="h-4 w-4 mr-2" />
          Resume Test
        </Button>
      </div>
    </Card>
  );
}
